/* ============================================================
   Peak Mode Supplements — theme.js
   Session 1 file — paste your full Session 1 JS here
   This file should contain:
   - Cart drawer open/close + item rendering
   - FAQ accordion (for non-page.faq uses)
   - Mobile nav toggle
   - Announcement bar dismiss
   - Cart count refresh
   ============================================================ */

(function() {
  'use strict';

  // ── Cart Drawer ───────────────────────────────────────────
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.addEventListener('cart:open', openCartDrawer);

  var cartBtn = document.querySelector('.cart-btn');
  if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);

  var cartClose = document.querySelector('.cart-drawer__close');
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
      })
      .catch(function(e) { console.error('Cart refresh error:', e); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    var itemsEl = document.getElementById('cart-items');
    var footerEl = document.querySelector('.cart-drawer__footer');
    var subtotalEl = document.getElementById('cart-subtotal');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--outline">Shop Products</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += '<div class="cart-item__img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>';
      html += '<div class="cart-item__info">';
      html += '<p class="cart-item__title">' + item.product_title + '</p>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cart-item__variant">' + item.variant_title + '</p>';
      }
      html += '<div class="cart-item__bottom">';
      html += '<div class="cart-item__qty">';
      html += '<button class="cart-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="cart-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
      html += '</div>';
      html += '<p class="cart-item__price">' + formatMoney(item.line_price) + '</p>';
      html += '</div>';
      html += '</div>';
      html += '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove item">×</button>';
      html += '</div>';
    });
    itemsEl.innerHTML = html;

    // Bind qty + remove events
    itemsEl.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, qty);
      });
    });
    itemsEl.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Mobile Nav ────────────────────────────────────────────
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function() {
      var open = mobileNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // ── Announcement bar dismiss ──────────────────────────────
  var announceClose = document.querySelector('.announcement__close');
  var announceBar = document.querySelector('.announcement-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', function() {
      announceBar.style.display = 'none';
      try { sessionStorage.setItem('pm_announce_dismissed', '1'); } catch(e) {}
    });
    try {
      if (sessionStorage.getItem('pm_announce_dismissed')) announceBar.style.display = 'none';
    } catch(e) {}
  }

  // ── Sticky header shadow on scroll ───────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ── Init cart count on load ───────────────────────────────
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});

})();

// ── Global Add to Cart from Grid (used by featured-products + collection) ──
function addToCartFromGrid(btn) {
  var variantId = parseInt(btn.dataset.variantId, 10);
  if (!variantId || btn.disabled) return;
  var orig = btn.innerHTML;
  btn.disabled = true;
  btn.textContent = '✓';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    setTimeout(function() { btn.disabled = false; btn.innerHTML = orig; }, 1800);
  })
  .catch(function() { btn.disabled = false; btn.innerHTML = orig; });
}

// ── Search toggle ──
(function() {
  var searchBtn = document.querySelector('.header-search-btn');
  var searchDrawer = document.querySelector('.search-drawer');
  var searchClose = document.querySelector('.search-drawer__close');
  var searchInput = document.querySelector('.search-drawer__input');

  if (searchBtn && searchDrawer) {
    searchBtn.addEventListener('click', function() {
      searchDrawer.classList.toggle('open');
      if (searchDrawer.classList.contains('open') && searchInput) {
        setTimeout(function() { searchInput.focus(); }, 100);
      }
    });
  }
  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', function() {
      searchDrawer.classList.remove('open');
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchDrawer) searchDrawer.classList.remove('open');
  });
})();
